<template>
	<a-layout class="document-detail-layout">
		<div class="doc-info-head">
			<doc-manage-basic-info :basic-info="docBasicInfo" v-if="!refreshPage"></doc-manage-basic-info>
			<a-button class="doc-info-head-control" @click="changeConType" v-if="canEdit && docBasicInfo.is_complete && docBasicInfo.contract_type !== 6" size="small" type="primary">合同类型变更</a-button>
		</div>
		<div class="doc-info-content">
			<a-tabs v-model="activeKey" v-if="!refreshPage">
				<a-tab-pane
					:tab="item.val"
					:key="strFormateKey(index+1)"
					v-if="initMaxKey>=index+1"
					v-for="(item,index) in tabData"
				>
					<doc-basic-info
						v-if="item.val==='基本信息' && !refreshPage && activeKey===strFormateKey(index+1)"
						:basic-info-props="docBasicInfo"
						:can-edit="canEdit"
						@refresh="refresh"
						@update-doc="updateDocBasicInfo"
						:stepInfo="stepInfo(item,index+1)"
					></doc-basic-info>
					<doc-abstract
						v-if="item.val==='合同概况' && !refreshPage && activeKey===strFormateKey(index+1)"
						:basic-info-props="docBasicInfo"
						@change-step="changeStep"
						:can-edit="canEdit"
						@update-doc="updateDocBasicInfo"
						:stepInfo="stepInfo(item,index+1)"
					></doc-abstract>
					<document-money
						v-if="item.val==='合同金额' && !refreshPage && activeKey===strFormateKey(index+1)"
						:basic-info="docBasicInfo"
						@change-step="changeStep"
						@update-doc="updateDocBasicInfo"
						:can-edit="canEdit"
						:stepInfo="stepInfo(item,index+1)"
					></document-money>
					<doc-make-invoice
						v-if="item.val==='开票金额' && !refreshPage && activeKey===strFormateKey(index+1)"
						:basic-info="docBasicInfo"
						@change-step="changeStep"
						@update-doc="updateDocBasicInfo"
						:can-edit="canEdit"
						:stepInfo="stepInfo(item,index+1)"
					></doc-make-invoice>
					<doc-return-money
						v-if="item.val==='收款金额' && !refreshPage && activeKey===strFormateKey(index+1)"
						:basic-info="docBasicInfo"
						@change-step="changeStep"
						@update-doc="updateDocBasicInfo"
						:can-edit="canEdit"
						:stepInfo="stepInfo(item,index+1)"
					></doc-return-money>
					<doc-income-forecast
						v-if="item.val==='开票预测' && !refreshPage && activeKey===strFormateKey(index+1)"
						:basic-info="docBasicInfo"
						@change-step="changeStep"
						@update-doc="updateDocBasicInfo"
						:can-edit="canEdit"
						:stepInfo="stepInfo(item,index+1)"
					></doc-income-forecast>
					<doc-project-maintenance
						v-if="item.val==='项目执行及维护' && !refreshPage && activeKey===strFormateKey(index+1)"
						:basic-info-props="docBasicInfo"
						@update-doc="updateDocBasicInfo"
						@change-step="changeStep"
						:can-edit="canEdit"
						:stepInfo="stepInfo(item,index+1)"
					></doc-project-maintenance>
          <contract-duty
          v-if="item.val==='履约义务' && !refreshPage&& activeKey===strFormateKey(index+1)"
          :basic-info-props="docBasicInfo"
          @change-step="changeStep"
          :stepInfo="stepInfo(item,index+1)"
          :can-edit="canEdit"
          ></contract-duty>
				</a-tab-pane>
				<!-- <a-tab-pane tab="合同基本信息" key="1" v-if="tabData.indexOf(1)!==-1 && initMaxKey>=1">
          <doc-basic-info v-if="activeKey==='1' && !refreshPage" :basic-info-props="docBasicInfo" :can-edit="canEdit" @refresh="refresh" @update-doc="updateDocBasicInfo"></doc-basic-info>
				</a-tab-pane>-->
				<!-- <a-tab-pane tab="合同概况" key="2" v-if="tabData.indexOf(2)!==-1 && initMaxKey>=2">
          <div v-if="activeKey==='2'">
            <doc-abstract v-if="!refreshPage" :basic-info-props="docBasicInfo" @change-step="changeStep" :can-edit="canEdit" @update-doc="updateDocBasicInfo"></doc-abstract>
          </div>
        </a-tab-pane>
        <a-tab-pane tab="合同金额" key="3" v-if="tabData.indexOf(3)!==-1 && initMaxKey>=3">
          <document-money v-if="activeKey==='3' && !refreshPage" :basic-info="docBasicInfo" @change-step="changeStep" @update-doc="updateDocBasicInfo" :can-edit="canEdit"></document-money>
        </a-tab-pane>
        <a-tab-pane tab="开票金额" key="4" v-if="tabData.indexOf(4)!==-1 && initMaxKey>=4">
          <doc-make-invoice v-if="activeKey==='4' && !refreshPage" :basic-info="docBasicInfo" @change-step="changeStep" @update-doc="updateDocBasicInfo" :can-edit="canEdit"></doc-make-invoice>
        </a-tab-pane>
        <a-tab-pane tab="收款金额" key="5" v-if="tabData.indexOf(5)!==-1 && initMaxKey>=5">
          <doc-return-money v-if="activeKey==='5' && !refreshPage" :basic-info="docBasicInfo" @change-step="changeStep" @update-doc="updateDocBasicInfo" :can-edit="canEdit"></doc-return-money>
        </a-tab-pane>
        <a-tab-pane tab="开票预测" key="6" v-if="tabData.indexOf(6)!==-1 && initMaxKey>=6">
          <doc-income-forecast v-if="activeKey==='6' && !refreshPage" :basic-info="docBasicInfo" @change-step="changeStep" @update-doc="updateDocBasicInfo" :can-edit="canEdit"></doc-income-forecast>
        </a-tab-pane>
        <a-tab-pane tab="项目执行及维护" key="7" v-if="tabData.indexOf(7)!==-1 && initMaxKey>=7">
          <doc-project-maintenance v-if="activeKey==='7' && !refreshPage" :basic-info-props="docBasicInfo" @update-doc="updateDocBasicInfo" @change-step="changeStep" :can-edit="canEdit"></doc-project-maintenance>
				</a-tab-pane>-->
			</a-tabs>
		</div>
		<a-modal title="合同类型变更" v-model="showModifyModal" width="640px" @ok="handleOk" :confirm-loading="submitLoading">
			<a-form :form="modalForm">
				<a-form-item label="变更前" :label-col="{span: 4,}" :wrapper-col="{span: 16,}">
				{{ docBasicInfo.contract_type_desc }}
				</a-form-item>
				<a-form-item label="变更后" :label-col="{span: 4,}" :wrapper-col="{span: 16,}">
					<a-select v-decorator="[
						'type',
						{rules: [{required: true, message: '必填!',}]}
						]" placeholder="请选择">
						<template v-for="(status, index) in docTypes.contract_type">
							<a-select-option v-if="status.key !==6 && status.key !== docBasicInfo.contract_type"  :key="index" :value="status.key">{{status.val}}</a-select-option>
						</template>
					</a-select>
				</a-form-item>
				<a-form-item :wrapper-col="{span: 16, offset: 4}">
					请注意：<br>
					合同类型变更，若某些合同信息在变更后的合同类型中无相应字段，则系统将自动丢弃。
				</a-form-item>

			</a-form>
		</a-modal>
	</a-layout>
</template>

<script>
import DocBasicInfo from './DocBasicInfo.vue';
import DocProjectMaintenance from './DocProjectMaintenance.vue';
import DocumentMoney from './DocumentMoney';
import DocMakeInvoice from './DocMakeInvoice.vue';
import DocReturnMoney from './DocReturnMoney';
import DocIncomeForecast from './DocIncomeForecast';
import DocAbstract from './DocAbstract.vue';
import ContractDuty from './ContractDuty.vue';
import {
  initDocOptions,
  addDoc,
  getDocType,
  getDocBasicInfo,
  changeContractType,
} from '../../services/DocService';

export default {
  components: {
    DocBasicInfo,
    DocAbstract,
    DocProjectMaintenance,
    DocMakeInvoice,
    DocumentMoney,
    DocReturnMoney,
    DocIncomeForecast,
    DocAbstract,
    ContractDuty
  },
  data() {
    return {
      refreshPage: false,
      breadcrumb: [
        {
          label: '合同管理',
          path: ''
        },
        {
          label: '合同信息',
          path: {
            name: 'document.list'
          }
        },
        {
          label: '合同详情',
          path: ''
        }
      ],
      btnText: {
        cancelText: '取消',
        okText: '保存'
      },
      contract_sn: undefined,
      canEdit: false,
      activeKey: '1',
      initMaxKey: null,
      tabData: [],
      docInfo: {},
      docBasicInfo: {},
      contract_id: 0,
      showModifyModal: false,
      modalForm: this.$form.createForm(this),
      docTypes: {},
      submitLoading: false,
    };
  },
  computed: {
    activeKeyNum() {
      return Number(this.activeKey);
    }
  },
  methods: {
    getDocType() {
      return getDocType().then((res) => {
        if (res.status === 'success') {
          this.docTypes = res.data.options;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    handleOk() {
      this.modalForm.validateFields((err, fieldsValue) => {
        if (err) {
          return;
        }
        const params = {
          id: this.docBasicInfo.contract_id,
          ...fieldsValue
        };
        this.submitLoading = true;
        changeContractType(params).then((res) => {
          if (res.status === 'success') {
            this.$Message.success('操作成功');
            this.showModifyModal = false;
            setTimeout(() => {
              location.reload();
            }, 500);
          } else {
            this.$Message.error(res.message);
          }
        }).finally(() => {
          this.submitLoading = false;
        });
      });
    },
    changeConType() {
      this.modalForm.resetFields();
      this.showModifyModal = true;
    },
    strFormateKey(key) {
      return key.toString();
    },
    fetchDocBasicInfo() {
      return getDocBasicInfo({ contract_id: this.contract_id }).then((res) => {
        if (res.status === 'success') {
          this.docBasicInfo = res.data.base_info;
          const curr_step_num =						res.data.base_info.step_num_list.findIndex(
						  value => value.key == res.data.base_info.curr_step_num
          ) + 1;
          this.docBasicInfo.curr_step_num = curr_step_num;
          this.tabData = res.data.base_info.step_num_list;
          this.max_step_num = this.tabData.length;
          if (this.canEdit) {
            if (this.docBasicInfo.curr_step_num <= this.max_step_num - 1) {
              const ind = this.docBasicInfo.curr_step_num + 1;
              this.activeKey = ind.toString();
              this.initMaxKey = ind;
            } else {
              this.activeKey = '1';
              this.initMaxKey = this.max_step_num;
            }
          } else {
            this.activeKey = '1';
            this.initMaxKey = this.docBasicInfo.curr_step_num;
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    updateDocBasicInfo() {
      return getDocBasicInfo({ contract_id: this.contract_id }).then((res) => {
        if (res.status === 'success') {
          this.docBasicInfo.differ_inv_rev = res.data.base_info.differ_inv_rev;
          this.docBasicInfo.differ_sign_inv =						res.data.base_info.differ_sign_inv;
          this.docBasicInfo.differ_sign_rev =						res.data.base_info.differ_sign_rev;
          this.docBasicInfo.archival_status_desc =						res.data.base_info.archival_status_desc;
          this.docBasicInfo.project_manager =						res.data.base_info.project_manager;
          this.docBasicInfo.salesman = res.data.base_info.salesman;
          this.docBasicInfo.contract_type_desc =						res.data.base_info.contract_type_desc;
          this.docBasicInfo.product_line_desc =						res.data.base_info.product_line_desc;
          this.docBasicInfo.contract_date = res.data.base_info.contract_date;
          this.docBasicInfo.is_complete = res.data.base_info.is_complete;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    changeStep(e) {
      if (e.next_step === e.curr_step_num) {
        this.$Message.success('合同信息创建完成');
      }
      this.updateDocBasicInfo();
      this.activeKey = e.next_step.toString();
      this.docBasicInfo.curr_step_num = e.curr_step_num;
      this.initMaxKey = e.next_step;
    },
    refresh(e) {
      this.canEdit = !!Number(this.$route.query.canEdit);
      const url = `${window.location.origin}/rws/document/documentDetail/${e}/create?canEdit=${this.canEdit}`;
      window.open(url, '_blank');
      // return;
      // this.$router.push({
      //   name: 'document.detail.create',
      //   params: { contract_sn: e },
      //   query: {
      //     canEdit: this.canEdit ? 1 : 0,
      //   },
      // });
      // this.canEdit = !!Number(this.$route.query.canEdit);
      // this.contract_sn = this.$route.params.contract_sn;
      // this.fetchDocBasicInfo().then(e => {
      //   this.refreshPage = true;
      //   this.$nextTick(() => {
      //     this.refreshPage = false;
      //   });
      // });
    },
    stepInfo(item, stepNum) {
      const index = this.tabData.indexOf(item);
      return {
        stepKey: item.key,
        stepName: item.val,
        stepNum,
        nextStepNum: index === this.max_step_num - 1 ? stepNum : stepNum + 1,
        nextStepName:
					index === this.max_step_num - 1 ? '' : this.tabData[index + 1].val
      };
    }
  },
  created() {
    this.canEdit = !!Number(this.$route.query.canEdit);
    this.contract_sn = this.$route.query.contract_sn;
    this.contract_id = this.$route.params.contract_id;
    this.fetchDocBasicInfo();
    this.getDocType();
  }
};
</script>

<style lang="less">
.doc-info {
	&-head {
		display: flex;
		position: relative;
		width: 100%;
		height: 128px;
		padding: 16px 32px;
		border-bottom: #ddd;
		box-sizing: border-box;
		justify-content: space-between;
		background: #fff;
		&-control {
			position: absolute;
			top: 90px;
			right: 32px;
			z-index: 999;
		}
	}
	&-content {
		padding: 0px 16px;
		margin-top: -44px;
		.ant-tabs-bar {
			border-bottom: none;
		}
		// background: #fff;
	}
}
.doc-num {
	display: flex;
	&-item {
		margin-right: 32px;
	}
	&-name {
		margin-right: 8px;
	}
}
</style>
